import { ScoringUpdates } from "@/data/match";
import { ScoringUpdates as DBScoringUpdates } from "@prisma/client";

export type BasicLeaguePlayer = {
  id: string;
  firstName: string;
  lastName: string;
  imageUrl: string | null;
};
export type BasicLeagueDouble = {
  id: string;
  leaguePlayerOne: BasicLeaguePlayer | null;
  leaguePlayerTwo: BasicLeaguePlayer | null;
};
export type GameWithPlayers = {
  homePlayer: BasicLeaguePlayer | null;
  awayPlayer: BasicLeaguePlayer | null;
  homeDouble: BasicLeagueDouble | null;
  awayDouble: BasicLeagueDouble | null;
};
interface MatchWithLineup {
  homePlayerOne: BasicLeaguePlayer | null;
  homePlayerTwo: BasicLeaguePlayer | null;
  homePlayerThree: BasicLeaguePlayer | null;
  homeSubstitutePlayerOne: BasicLeaguePlayer | null;
  homeSubstitutePlayerTwo: BasicLeaguePlayer | null;
  homeSubstitutePlayerThree: BasicLeaguePlayer | null;
  guestPlayerOne: BasicLeaguePlayer | null;
  guestPlayerTwo: BasicLeaguePlayer | null;
  guestPlayerThree: BasicLeaguePlayer | null;
  guestSubstitutePlayerOne: BasicLeaguePlayer | null;
  guestSubstitutePlayerTwo: BasicLeaguePlayer | null;
  guestSubstitutePlayerThree: BasicLeaguePlayer | null;
  games: GameWithPlayers[];
}

export function getLineupFromMatch(match: MatchWithLineup) {
  const game4 = match.games[3];

  const homePlayerOne =
    match.homePlayerOne ?? match.games[0]?.homePlayer ?? null;
  const homePlayerTwo =
    match.homePlayerTwo ?? match.games[1]?.homePlayer ?? null;
  const homePlayerThree =
    match.homePlayerThree ?? match.games[2]?.homePlayer ?? null;
  const game4HomePlayer = game4?.homePlayer ?? null;

  let homeSubstitutePlayerOne = match.homeSubstitutePlayerOne;
  let homeSubstitutePlayerTwo = match.homeSubstitutePlayerTwo;
  let homeSubstitutePlayerThree = match.homeSubstitutePlayerThree;
  if (
    game4HomePlayer &&
    game4HomePlayer.id !== homePlayerOne?.id &&
    game4HomePlayer.id !== homePlayerTwo?.id &&
    game4HomePlayer.id !== homePlayerThree?.id
  ) {
    homeSubstitutePlayerOne = game4HomePlayer;
  }
  const homeDouble = match.games[4]?.homeDouble;
  if (homeDouble) {
    if (
      homeDouble.leaguePlayerOne?.id !== homePlayerOne?.id &&
      homeDouble.leaguePlayerOne?.id !== homePlayerTwo?.id &&
      homeDouble.leaguePlayerOne?.id !== homePlayerThree?.id &&
      homeDouble.leaguePlayerOne?.id !== homeSubstitutePlayerOne?.id
    ) {
      if (homeSubstitutePlayerOne) {
        homeSubstitutePlayerTwo = homeDouble.leaguePlayerOne;
      } else {
        homeSubstitutePlayerOne = homeDouble.leaguePlayerOne;
      }
    }
    if (
      homeDouble.leaguePlayerTwo?.id !== homePlayerOne?.id &&
      homeDouble.leaguePlayerTwo?.id !== homePlayerTwo?.id &&
      homeDouble.leaguePlayerTwo?.id !== homePlayerThree?.id &&
      homeDouble.leaguePlayerTwo?.id !== homeSubstitutePlayerOne?.id &&
      homeDouble.leaguePlayerTwo?.id !== homeSubstitutePlayerTwo?.id
    ) {
      if (homeSubstitutePlayerTwo) {
        homeSubstitutePlayerThree = homeDouble.leaguePlayerTwo;
      } else if (homeSubstitutePlayerOne) {
        homeSubstitutePlayerTwo = homeDouble.leaguePlayerTwo;
      } else {
        homeSubstitutePlayerOne = homeDouble.leaguePlayerTwo;
      }
    }
  }

  const guestPlayerOne =
    match.guestPlayerOne ?? match.games[1]?.awayPlayer ?? null;
  const guestPlayerTwo =
    match.guestPlayerTwo ?? match.games[0]?.awayPlayer ?? null;
  const guestPlayerThree =
    match.guestPlayerThree ?? match.games[2]?.awayPlayer ?? null;
  const game4AwayPlayer = match.games[3]?.awayPlayer ?? null;

  let guestSubstitutePlayerOne = match.guestSubstitutePlayerOne;
  let guestSubstitutePlayerTwo = match.guestSubstitutePlayerTwo;
  let guestSubstitutePlayerThree = match.guestSubstitutePlayerThree;
  if (
    game4AwayPlayer &&
    game4AwayPlayer.id !== guestPlayerOne?.id &&
    game4AwayPlayer.id !== guestPlayerTwo?.id &&
    game4AwayPlayer.id !== guestPlayerThree?.id
  ) {
    guestSubstitutePlayerOne = game4AwayPlayer;
  }
  const guestDouble = match.games[4]?.awayDouble;
  if (guestDouble) {
    if (
      guestDouble.leaguePlayerOne?.id !== guestPlayerOne?.id &&
      guestDouble.leaguePlayerOne?.id !== guestPlayerTwo?.id &&
      guestDouble.leaguePlayerOne?.id !== guestPlayerThree?.id &&
      guestDouble.leaguePlayerOne?.id !== guestSubstitutePlayerOne?.id
    ) {
      if (guestSubstitutePlayerOne) {
        guestSubstitutePlayerTwo = guestDouble.leaguePlayerOne;
      } else {
        guestSubstitutePlayerOne = guestDouble.leaguePlayerOne;
      }
    }
    if (
      guestDouble.leaguePlayerTwo?.id !== guestPlayerOne?.id &&
      guestDouble.leaguePlayerTwo?.id !== guestPlayerTwo?.id &&
      guestDouble.leaguePlayerTwo?.id !== guestPlayerThree?.id &&
      guestDouble.leaguePlayerTwo?.id !== guestSubstitutePlayerOne?.id &&
      guestDouble.leaguePlayerTwo?.id !== guestSubstitutePlayerTwo?.id
    ) {
      if (guestSubstitutePlayerTwo) {
        guestSubstitutePlayerThree = guestDouble.leaguePlayerTwo;
      } else if (guestSubstitutePlayerOne) {
        guestSubstitutePlayerTwo = guestDouble.leaguePlayerTwo;
      } else {
        guestSubstitutePlayerOne = guestDouble.leaguePlayerTwo;
      }
    }
  }

  return {
    homePlayerOne,
    homePlayerTwo,
    homePlayerThree,
    homeSubstitutePlayerOne,
    homeSubstitutePlayerTwo,
    homeSubstitutePlayerThree,
    homeDouble: homeDouble ?? null,
    guestPlayerOne,
    guestPlayerTwo,
    guestPlayerThree,
    guestSubstitutePlayerOne,
    guestSubstitutePlayerTwo,
    guestSubstitutePlayerThree,
    awayDouble: guestDouble ?? null,
  };
}

export function sortScoringUpdates(
  updates: (ScoringUpdates | DBScoringUpdates)[]
) {
  return updates.sort((a, b) => {
    if (a.index && b.index) {
      if (a.index !== b.index) {
        return a.index - b.index;
      }
    }
    if (a.ts === b.ts) {
      const typeOrder = [
        "Point",
        "EventSetEnd",
        "EventGameEnd",
        "SwitchDoublesGame",
        "EventGameStart",
        "EventSetStart",
      ];
      return typeOrder.indexOf(a.type) - typeOrder.indexOf(b.type);
    }
    return Number(a.ts) - Number(b.ts);
  });
}

export function updatesToSerialized(scoringUpdates: DBScoringUpdates[]) {
  const serialized = scoringUpdates.map((update) => {
    const ts = Number(update.ts);
    return { ...update, ts };
  });
  return serialized as unknown as ScoringUpdates[];
}
